import comp from "./RadialProgressBar";
export default comp;
